module.exports = __webpack_public_path__ + "img/box3_right.1e3c580d.png";